import useEventListener from "@use-it/event-listener";
import moment from "moment";
import React, { useEffect, useReducer, useRef, useState } from "react";
import { addTestResult } from "../../api/addTestResult";
import { getStudentData } from "../../helper/localStorage";
import { totalTimeOrScore } from "../../helper/scoreCounter";
import { answeredQues } from "../../helper/testHelper";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import "./CPT.scss";

const getRandomBtw = (min, max) => {
  let rand = Math.random() * (max - min) + min;
  rand = Math.floor(rand);
  return rand;
};

const initialValue = {
  active: false, //  active contain binary as well as numeric value
  afterActive: false, // after que disappear in 250ms afterActive became true
  isNext: false,
  startTime: null,
  correct: false,
  commission: false,
  omission: true,
  quick: false,
  actualStartTime: "",
  // 14-june-2021
  alphabetShownStartTime: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case "TEST_STARTED": {
      return { ...state, actualStartTime: moment() };
    }
    case "ACTIVE":
      return {
        ...state,
        active: action.payload,
        // 14-june-2021
        alphabetShownStartTime: moment(),
      };

    case "START_TIME":
      return { ...state, startTime: moment() };

    case "AFTER_ACTIVE":
      return { ...state, afterActive: true }; // after que disappear in 250ms

    case "MOVE_TO_NEXT":
      return { ...state, isNext: true };

    case "QUICK_TAP":
      return { ...state, quick: true, omission: false };

    case "CORRECT_TAP":
      return { ...state, correct: true, omission: false };

    case "INCORRECT_TAP":
      return { ...state, commission: true, omission: false };

    case "RESET":
      return { ...initialValue };

    default:
      return state;
  }
};

export default function CPT({ question, questions, index }) {
  const [CPT, dispatchCPT] = useReducer(reducer, initialValue);
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();
  const notX = question.letter.toLowerCase() !== "x";
  const tapBtn = useRef(null);
  let {
    active,
    isNext,
    afterActive,
    startTime,
    omission,
    commission,
    quick,
    correct,
    actualStartTime,
    alphabetShownStartTime,
  } = CPT;

  // get question display in 50ms
  useEffect(() => {
    dispatchCPT({ type: "RESET" });
    dispatchCPT({ type: "TEST_STARTED" });
    console.log("useEffect CPT.js question", question);
    // initially it takes 5 sec to start appearing alphabet then it 50ms
    const timeToShowAlphabet = question.id === 1 ? 5000 : 50;

    const timeout = setTimeout(() => {
      handleActive();
    }, timeToShowAlphabet);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  // handle active in between range of 0-9 with and appearing time of 250ms
  const handleActive = () => {
    dispatchCPT({ type: "ACTIVE", payload: getRandomBtw(0, 9) });
    dispatchCPT({ type: "START_TIME" });
    const timeout = setTimeout(() => {
      dispatchCPT({ type: "ACTIVE", payload: false });
      dispatchCPT({ type: "AFTER_ACTIVE" });
    }, 250);
    return () => {
      clearTimeout(timeout);
    };
  };

  const [tapped, setTapped] = useState(false);
  // get next question display with 1.2s to 3s delay
  useEffect(() => {
    if (afterActive) {
      const randTime = getRandomBtw(12, 31) * 100;

      const timeoutTapped = setTimeout(() => {
        // setTapped(false);
      }, randTime - 250);

      const timeout = setTimeout(
        () => {
          dispatchCPT({ type: "MOVE_TO_NEXT" });
        },
        // 500
        randTime
      );
      return () => {
        clearTimeout(timeout);
        clearTimeout(timeoutTapped);
      };
    }
  }, [afterActive]);

  // next trigger whenever isNext became true
  useEffect(() => {
    if (isNext) {
      handleNext();
    }
  }, [isNext]);

  const handleNext = () => {
    const noTapCorrect = omission && !notX; //special case of correct when user leave tap at x

    const answer_flag = quick
      ? "Quick Tap"
      : omission && !noTapCorrect
      ? "Omission"
      : commission
      ? "Commission"
      : "";
    const que_score = quick ? 1 : correct ? 1 : noTapCorrect ? 1 : -1;
    // const answer = quick ? "Q" : correct ? "Y" : noTapCorrect ? "Y" : "N";
    const answer = quick
      ? "Y"
      : correct
      ? "Y"
      : noTapCorrect
      ? "N"
      : commission
      ? "Y"
      : "N";

    const value = {
      answer_flag,
      answer,
      que_score,
      que_id: question.id,
    };

    // const timeSpend = moment().diff(actualStartTime);
    // 14 june 2021
    const timeSpend = moment().diff(alphabetShownStartTime);
    const alphabetShownTimeSpend = moment().diff(alphabetShownStartTime);

    console.log(
      "timeSpend(actualTimeSpend) , timeSpend(startTime), alphabetShownTimeSpend",
      timeSpend,
      moment().diff(startTime),
      alphabetShownTimeSpend
    );

    dispatchAnswer({
      type: "ADD_ANSWER",
      payload: answeredQues("tap_letter", value, question, timeSpend),
    });

    //FIXME
    if (index < questions.length - 1) {
      // handling next
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: questions[index + 1].id, //next ques index
      });
    } else {
      // on last question and submitting logic
      let answerRes = [
        ...answerC.answers,
        answeredQues("tap_letter", value, question, timeSpend),
      ];

      const grade_id = JSON.parse(localStorage.getItem("gradeId"));
      const { login_id } = getStudentData();
      const { player_time, player_score } = totalTimeOrScore(
        answerRes,
        questions
      );

      let myCommission = 0;
      let quickTap = 0;
      let totalScore = player_score;

      answerRes.forEach((answer) => {
        if (answer.answer_flag === "Quick Tap") {
          quickTap = quickTap + 1;
          answer.answer = "Y";
        }

        if (answer.answer_flag === "Commission") {
          myCommission = myCommission + 1;
        }
      });

      if (myCommission > 2 && quickTap > 8) {
        const tapToLess = quickTap - 8;
        totalScore = totalScore - tapToLess;
      }

      const formatValue = {
        grade_id,
        player_id: login_id,
        res: answerRes,
        player_image: "",
        player_time,
        total_tap: helperC.totalTap,
        player_score: Math.sign(totalScore) === -1 ? 0 : totalScore,
        test_id: 190425225040,
      };

      // api hitting to send data to server
      addTestResult(formatValue, dispatchHelper, dispatchAnswer);

      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: "submitted",
      });
    }
  };

  const justTap = () => {
    setTapped(true);
    setTimeout(() => {
      setTapped(false);
    }, 200);
  };

  const handleTap = () => {
    justTap();
    const isQuick = moment().diff(startTime) < 300;
    dispatchHelper({ type: "SET_TOTAL_TAP" });
    console.log("tap number", helperC.totalTap + 1);
    // question not contain value x and user tap is the correct tap
    if (notX && isQuick) {
      dispatchCPT({ type: "QUICK_TAP" });
    } else if (notX) {
      dispatchCPT({ type: "CORRECT_TAP" });
    } else dispatchCPT({ type: "INCORRECT_TAP" });
  };

  const SPACE_KEYS = ["32", " "];
  function spaceKeyHandler({ key }) {
    if (SPACE_KEYS.includes(String(key))) {
      tapBtn && tapBtn.current.click();
    }
  }
  useEventListener("keyup", spaceKeyHandler);

  return (
    <div className="cpt-test">
      <p className="cpt-test-inst">
        Tap box at bottom when letter other than X display in upper box
      </p>
      <div className="letter-shown-area">
        {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((pos) => {
          return (
            <div
              key={pos}
              className={`letter-shown ${active === pos && "active"}`}
            >
              {active === pos && questions[index].letter}
            </div>
          );
        })}
      </div>

      <div
        className={`user-tap-area ${startTime && "can-tap"} ${
          // !omission &&
          tapped && "tapped" //omission false mean button is tapped
          //tapped variable set for disappearing 250ms before next question
        }`}
        ref={tapBtn}
        onClick={() => {
          if (startTime) {
            handleTap();
          } else justTap();
        }}
      ></div>
      <h4 className="tap-msg">Tap in the above Box or Press Spacebar</h4>
    </div>
  );
}
